import OrderPage from './order';

export default OrderPage;
